import { type BlobWithFilename, type DocumentError, isBlobWithFilename } from 'apiConnector/document/document';
import { useState } from 'react';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { downloadFile } from 'utils/documents/downloadDocument';

export const useGenerateDocument: (
  fetch: (localeCode: string) => Observable<Blob | BlobWithFilename>,
  onError: (localeCode: string, err: DocumentError) => void,
) => [boolean, (localeCode: string) => void] = (fetch, onError) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const callback = (locale: string) => {
    setIsDownloading(true);
    fetch(locale)
      .pipe(
        finalize(() => {
          setIsDownloading(false);
        }),
      )
      .subscribe({
        next(result) {
          if (isBlobWithFilename(result)) {
            downloadFile(result.blob, result.filename);
          } else {
            downloadFile(result);
          }
        },
        error(err: DocumentError) {
          onError(locale, err);
        },
      });
  };

  return [isDownloading, callback];
};
